import React, { useState } from "react";

import axios from "axios";
import IssuerRequestedProductsPage from "./IssuerRequestedProducts";
import IssuerGrantedProductsPage from "./IssuerGrantedProducts"

import LoadingGif from "../../../assets/images/Spin_loader.gif"


function Issuer({setParentLoading, activeIssuerTab}) {
    

    return (
        <div >

           

                {/* CONTENTS */}

                <div
                     style={{
                    width: "100%",
                    minHeight: "100vh",
                    overflowY: "auto",
                    backgroundColor: "white",
                    padding: "10px",
                    boxSizing: "border-box"
                    }}
                >

                    {/* REQUESTED PRODUCTS */}

                    {activeIssuerTab === "issuerrequestedproducts" &&
                        <div className="fade-container">
                           <IssuerRequestedProductsPage setParentLoading={setParentLoading} />
                        </div>
                    }

                    {/* GRANTED PRODUCTS */}

                    {activeIssuerTab === "issuergrantedproducts" &&
                        <div className="fade-container">
                            <IssuerGrantedProductsPage setParentLoading={setParentLoading} />
                        </div>
                    }

                    {/* REPLACEMENT PRODUCTS */}

                    {activeIssuerTab === "issuerreplacementproducts" && <div className="fade-container">
                       <b>This page is under construction...</b>
                    </div>
                    }
                  


                </div>
           

        </div>
    )
}

export default Issuer;